import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
import { Props } from './type'
export const PlusIcon = (props: Props) => (
  <Svg viewBox='0 0 20 20' fill='none' {...props}>
    <Path
      d='M10.0001 4.16675V15.8334M4.16675 10.0001H15.8334'
      stroke='#425563'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
